import React from "react"
import { useNavigate } from "react-router-dom"
import { News } from "src/openapi"

import { Box, Image, Typography } from "src/UILibrary"

type Props = {
  item: News
}

export const InterviewItem = ({ item }: Props) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{ p: "1.25rem  0.625rem", ":hover": { opacity: 0.8, cursor: "pointer" } }}
      onClick={() => navigate(`/news/${item.id}`)}
    >
      <Image
        src={item.imageUrl as string}
        sx={{ height: 160, bgcolor: "divider" }}
        alt=""
        imageStyle={{ width: "100%", height: "100%" }}
      />
      <Typography.SubTitleNormal
        color="textPrimary"
        my={1.25}
        lineHeight={1.25}
        sx={{
          fontFamily: "Noto Sans JP !important",
          display: "-webkit-box",
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
        }}
      >
        {item.title}
      </Typography.SubTitleNormal>
    </Box>
  )
}
